import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './ui/App'
import { Amplify } from 'aws-amplify'
import { defaultStorage } from 'aws-amplify/utils'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { Routes } from './ui/common/routes'
import { appConfig } from './ui/core/config'

/**
 * Urls used to setup redirects
 */
const urls = [
  import.meta.env.DEV ? 'http://localhost:5173' : '',
  'https://partyguestbook.com',
  'https://d2b0n1q0o055r3.cloudfront.net', // dev deploy
]

/**
 * Configure Amplify
 *
 * AWS custom config to drop into amplify. This is pulling from the cdk outputs' stacks
 * which is generated by a script when the app deploys.
 */
Amplify.configure({
  // How to configure https://docs.amplify.aws/javascript/tools/libraries/configure-categories/
  API: {
    REST: {
      [appConfig.amplifyConfig.restApi.name]: {
        endpoint: appConfig.amplifyConfig.restApi.endpoint,
        region: appConfig.amplifyConfig.restApi.region,
      },
    },
  },
  Auth: {
    Cognito: {
      userPoolId: appConfig.amplifyConfig.auth.userPoolId,
      userPoolClientId: appConfig.amplifyConfig.auth.userPoolClientId,
      identityPoolId: appConfig.amplifyConfig.auth.identityPoolId,
      loginWith: {
        oauth: {
          domain: appConfig.amplifyConfig.auth.userPoolDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: urls.map((url) => `${url}${Routes.redirectPage}`),
          redirectSignOut: urls,
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
})
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage)

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
